import { render } from "./RegistryCard.vue?vue&type=template&id=021fb0c9&scoped=true"
import script from "./RegistryCard.vue?vue&type=script&lang=js"
export * from "./RegistryCard.vue?vue&type=script&lang=js"

import "./RegistryCard.vue?vue&type=style&index=0&id=021fb0c9&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021fb0c9"]])

export default __exports__